<div class="container">
  <div class="modalHeader">
    <div class="d-flex justify-content-end mt-1">
      <app-dialog-button></app-dialog-button>
    </div>

    <div class="title-modal-mat">{{ titulo }}</div>
    <p class="excel-dialog-sub">{{ descricao }}</p>
  </div>

  <div mat-dialog-content>
    <input
      #arquivoExcel
      hidden
      type="file"
      [accept]="extensaoAceita"
      (change)="aoSelecionarArquivo($event)">

    <button
      type="button"
      class="wizard-dropzone"
      [class.arrastando]="arrastando"
      [disabled]="lendo"
      title="Selecionar a planilha"
      (click)="arquivoExcel.click()"
      (dragover)="aoArrastar($event)"
      (dragleave)="aoSairDoArraste($event)"
      (drop)="aoSoltar($event)">
      <i-lucide name="file-spreadsheet" size="26" class="wizard-dropzone-icone"></i-lucide>

      <span class="wizard-dropzone-titulo">
        {{ lendo ? 'Lendo a planilha...' : 'Arraste a planilha ou clique para selecionar' }}
      </span>

      <span class="wizard-dropzone-dica">
        {{ nomeArquivo || 'Arquivo no formato ' + extensaoAceita }}
      </span>
    </button>

    @if (previa; as dados) {
      <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-3">
        <h6 class="excel-dialog-titulo mb-0">Pré-visualização</h6>
        <span class="tabela-paginacao-info">Total de linhas: {{ dados.totalLinhas }}</span>
      </div>

      @if (temErros) {
        <div class="excel-dialog-erros mt-3">
          <i-lucide name="triangle-alert" size="18"></i-lucide>

          <div>
            <strong>Erros encontrados</strong>
            <ul>
              @for (erro of dados.erros; track $index) {
                <li>{{ erro }}</li>
              }
            </ul>
          </div>
        </div>
      }

      @if (temLinhas) {
        <div class="tabela-wrapper-adm excel-dialog-tabela mt-3">
          <table class="table table-custom-adm table-hover align-middle" style="width: 100%;">
            <thead class="table-light">
              <tr>
                @for (coluna of dados.colunas; track $index) {
                  <th class="text-nowrap">{{ coluna }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (linha of dados.linhas; track $index) {
                <tr>
                  @for (coluna of dados.colunas; track $index) {
                    <td>{{ linha[coluna] }}</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <p class="text-center noticias-vazio mt-3 mb-0">
          Nenhuma linha encontrada na planilha.
        </p>
      }
    }

    <div class="d-flex justify-content-end my-3 gap-2">
      <button type="button" class="btn btn-cancelar-modal" mat-dialog-close title="Cancelar">
        Cancelar
      </button>

      <button
        type="button"
        class="btn btn-import"
        title="Confirmar importação"
        [disabled]="!previa || lendo"
        (click)="confirmar()">
        Confirmar
      </button>
    </div>
  </div>
</div>
